import { createWeb3Modal } from '@web3modal/wagmi/react';
import { config, projectId } from './wagmi';
import { bsc } from 'wagmi/chains';

// Create Web3Modal with Featured Wallets
createWeb3Modal({
  wagmiConfig: config,
  projectId,
  chains: [bsc],
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#e50914',
    '--w3m-border-radius-master': '14px',
    '--w3m-font-family': 'Sora, system-ui, sans-serif'
  },
  // Featured wallets: Trust Wallet, SafePal, MetaMask, Binance, OKX
  featuredWalletIds: [
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // Trust Wallet  
    '163d2cf19babf05eb8962e9748f9ebe613ed52ebf9c8107c9a0f104bfcf161b3', // SafePal
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // MetaMask
    '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4', // Binance Web3 Wallet
    '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709'  // OKX Wallet
  ],
  // Exclude Brave Wallet
  excludeWalletIds: [
    '8308656f4548bb81b3508afe355cfbb7f0cb6253d1cc7f998080601f838ecee3' // Brave Wallet
  ],
  enableAnalytics: true,
  enableOnramp: false
});
